import { render, staticRenderFns } from "./dr-login.vue?vue&type=template&id=cac880d8"
import script from "./dr-login.vue?vue&type=script&lang=js"
export * from "./dr-login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports